



































































































































import { hanldeUserStatus } from '@/helpers/Common'
import FormatDate from '@/helpers/FormatDate'
import PreviewText from '@/helpers/PreviewText'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ChatListDisplay extends Vue {
  @Prop() groupChats!: any[]
  @Prop() disabledCheckbox!: boolean
  ATTACH_FILE: string = 'ATTACH_FILE'
  MESSAGE_DELETED: string = 'MESSAGE_DELETED'
  LEAVE_GROUP_CHAT: string = 'LEAVE_GROUP_CHAT'
  LEAVE_SYSTEM: string = 'LEAVE_SYSTEM'
  avatarDefault = require('@/assets/images/avatar-default.png')

  isDisableCheckbox(item: any) {
    const checkedItem = this.groupChats.find(t => t.checked)

    if (!checkedItem) {
      return false
    }

    return Boolean(item.is_pin) !== Boolean(checkedItem.is_pin)
  }

  getChatBoxAvatar(group: any): any[] {
    return group.user_group_chat.slice(0, 4)
  }

  getUserAvatar(user: any): string {
    return user && user.user_profile && user.user_profile.avatar
      ? user.user_profile.avatar
      : ''
  }

  togglePinChatGroup(group: any) {
    this.$emit('togglePinChatGroup', group)
  }

  goToGroupChatDetailRoute(group: any) {
    return {
      name: 'chat-detail',
      params: { groupChatId: `${group.id}` }
    }
  }

  handleSetGroupChatName(group: any) {
    if (!group.only_user) {
      return group.name
    }

    const groupChatName = group.user_leave_chat
      ? [
          {
            name: hanldeUserStatus(
              group.user_leave_chat.name,
              group.user_leave_chat.leaveType
            )
          }
        ]
      : group.user_group_chat

    if (!groupChatName || groupChatName.length === 0) {
      return ''
    }

    const suffix = this.$t('common.suffix.san')
    const comma = this.$t('chat.comma')

    const displayUsers = groupChatName.slice(0, 2)
    const mappedNames = displayUsers
      .map((item: any) => item.name)
      .join(`${suffix}${comma}`)

    const groupName = `${mappedNames}${suffix}`

    const otherUserCount = Math.max(0, groupChatName.length - 2)
    const extraText =
      otherUserCount > 0
        ? this.$t('chat.chat_group_name_with', {
            other_user_count: otherUserCount
          })
        : ''

    return `${groupName}${extraText}${this.$t('chat.chat_with')}`
  }

  groupChatLastMess(group: any) {
    const content = group.last_message
    const contentText = group.content_text

    const text = content?.split(',')[0]

    switch (text) {
      case this.ATTACH_FILE:
        return this.$t('common.message.chat_no_content')
      case this.MESSAGE_DELETED:
        return this.$t('chat.list.msg.msg_deleted')
      case this.LEAVE_GROUP_CHAT:
        return this.$t('chat.list.msg.leave_group_chat', {
          name: content.split(',')[1]
        })
      case this.LEAVE_SYSTEM:
        return this.$t('chat.list.msg.leave_system', {
          name: content.split(',')[1]
        })
      default:
        return contentText ? contentText : this.$t('common.message.chat_no_content')
    }
  }

  handleSender(sender: any) {
    if (!sender) return { name: '', text: '' }
    let text = hanldeUserStatus(sender.name, sender.user_active_status)
    const preview = PreviewText.covertToPreviewText(text)
    return {
      name: text,
      text: preview.text
    }
  }

  formatDateWithDays(date: string) {
    return FormatDate.formatDateWithDays(date)
  }

  markReadGroupChat(index: number) {
    this.$emit('markReadGroupChat', index)
  }

  handleCheckItem() {
    const hasAnyChecked = this.groupChats.some(item => item.checked)

    const unpinGroupChats = this.groupChats.filter(item => !item.is_pin)
    const pinGroupChats = this.groupChats.filter(item => item.is_pin)

    const allUnpinChecked =
      unpinGroupChats.length > 0 && unpinGroupChats.every(item => item.checked)

    const allPinChecked =
      pinGroupChats.length > 0 && pinGroupChats.every(item => item.checked)

    if (allUnpinChecked || allPinChecked) {
      this.$emit('addCheckAll')
    } else {
      this.$emit('removeCheckAll')
    }

    this.$emit('selectAnyItem', hasAnyChecked)
  }
}
